import { httpNoLoading } from './configNoLoading'
import { http } from './config'
import ServicoBuscaSession from './servicoBuscaSession'

function adicionarContextoBusca(config) {
    config.params = Object.assign({}, config.params || {});

    return ServicoBuscaSession.obterContexto().then((contexto) => {
        config.params.codigoSessaoBusca = contexto.valor;
        config.params.anonymousConsumer = contexto.anonymousConsumer;
        return config;
    }).catch(() => {
        return config;
    });
}

function salvarContextoBusca(response) {
    const dados = response && response.data;
    ServicoBuscaSession.salvarSearchId(
        dados && dados.servicoBuscaAtivo ? dados.searchId : null
    );
}

function processarRespostaBusca(promise) {
    return promise.then(
        (response) => {
            salvarContextoBusca(response);
            return response;
        },
        (error) => {
            salvarContextoBusca(error.response);
            return Promise.reject(error);
        }
    );
}

export default {
    getByCodigo: (codigo) => {
        return http.get('produto/codigo/' + codigo)
    },
    getProdutos: (data) => {
        return httpNoLoading.get('produto', data)
    },
    getListaProdutos: (data) => {
        return adicionarContextoBusca(Object.assign({}, data || {})).then((config) => {
            return processarRespostaBusca(
                httpNoLoading.get('produto/lista-produtos', config)
            );
        });
    },
    getSearchSuggestions: (data) => {
        return adicionarContextoBusca({
            params: {
                search: data
            }
        }).then((config) => {
            return httpNoLoading.get('produto/search-suggestions', config);
        });
    },
    getValoresCliente: (produto_codigo, cliente_codigo) => {
        return httpNoLoading.get('produto/' + produto_codigo + '/valores-cliente/' + cliente_codigo)
    },
    getValoresMargem: (produto_codigo, cliente_codigo, percentual_margem, valor_margem, quantidade, filial, idOrcamento = null) => {
        percentual_margem = parseFloat(new Intl.NumberFormat("en-US", { maximumFractionDigits: "2" }).format(percentual_margem));
        return httpNoLoading.get('produto/' + 'valores-margem/' + produto_codigo + "/" + cliente_codigo + "/" + percentual_margem + "/" + valor_margem + "/" + quantidade + "/" + filial + (idOrcamento ? ("/" + idOrcamento) : ""))
    },
    getEstoque: (data) => {
        return http.get('estoque/estoque_produtos?produtos=' + data);
    },
    favoritar: (produtoCodigo) => {
        return httpNoLoading.post('produto/favoritar/' + produtoCodigo);
    },
    desfavoritar: (id) => {
        return httpNoLoading.post('produto/desfavoritar/' + id);
    },
}
